// extracted by mini-css-extract-plugin
export default {"button":"InfoModal_button__KN354","logInWrapper":"InfoModal_logInWrapper__UD4eU","close":"InfoModal_close__+9hng","buttons":"InfoModal_buttons__ZdKrV"};